__turbopack_context__.v({
  "arrow": "Popup-module-scss-module__L05NsG__arrow",
  "blocksBackgroundColor": "Popup-module-scss-module__L05NsG__blocksBackgroundColor",
  "blocksFontColor": "Popup-module-scss-module__L05NsG__blocksFontColor",
  "bottom": "Popup-module-scss-module__L05NsG__bottom",
  "left": "Popup-module-scss-module__L05NsG__left",
  "right": "Popup-module-scss-module__L05NsG__right",
  "secondaryNavBackgroundColor": "Popup-module-scss-module__L05NsG__secondaryNavBackgroundColor",
  "themeBackgroundColor": "Popup-module-scss-module__L05NsG__themeBackgroundColor",
  "themeFontColor": "Popup-module-scss-module__L05NsG__themeFontColor",
  "themeFontFamily": "Popup-module-scss-module__L05NsG__themeFontFamily",
  "top": "Popup-module-scss-module__L05NsG__top",
});
